import React from 'react';

/**
 * Icone de alerta de advertência
 * @param {number} number - O número a ser exibido no ícone.
 * @returns {ReactComponentElement} 
 */
const AdvertenciaIcon = ({ number, width, height, fill }) => {
    return (
        <svg width={width ? width : '20'} height={height ? height : '20'} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8.95508" y="0.441758" width="11.3961" height="11.3961" rx="0.857426" transform="rotate(45 8.95508 0.441758)" fill={fill ? fill : "#EABC1A"} stroke={fill ? fill : "#EABC1A"} strokeWidth="0.789474"/>
            <text x="9" y="13.5" textAnchor="middle" fontSize="15" fill="#FFFFFF" fontFamily="Segoe UI, sans-serif">{number}</text>
        </svg>
    );
}

export default AdvertenciaIcon;
